import { render, staticRenderFns } from "./CompanyPageInfo.vue?vue&type=template&id=3f0ed7a4&"
import script from "./CompanyPageInfo.vue?vue&type=script&lang=ts&"
export * from "./CompanyPageInfo.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyPageInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports